import { ROOT_URL } from '../../../constants/Config';
import axios from 'axios';

export const Steps = {
  Phone: 'phone',
  Code: 'code'
};

export const Types = {
  Call: 'call',
  Sms: 'sms'
};

export const sendPhone = async ({ phone, type }) => {
  const url = type === Types.Call ? `${ROOT_URL}/calls/makecall` : `${ROOT_URL}/user/send/sms`;

  try {
    await axios.post(url, {
      phone: phone.match(/\d+/g).join('')
    });

    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error.response.data.error['error-code']);
  }
};



// WEBPACK FOOTER //
// ./src/containers/Login/Form/common.js